// AUPRÉA — Liste des factures (admin voit tout, consultant voit les siennes)
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Alert, Spinner, fmtEur } from "./shared";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: BACKEND + "/api" });
api.interceptors.request.use((c) => {
  const tok = localStorage.getItem("auprea_token");
  if (tok) c.headers.Authorization = `Bearer ${tok}`;
  return c;
});

const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString("fr-FR"); } catch { return iso; } };

export const FacturesPage = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/invoices").then(r => setInvoices(r.data))
      .catch(e => setErr(e?.response?.data?.detail || "Erreur"))
      .finally(() => setLoading(false));
  }, []);

  const download = async (id, num) => {
    try {
      const tok = localStorage.getItem("auprea_token");
      const r = await axios.get(`${BACKEND}/api/invoices/${id}/download`, {
        headers: { Authorization: `Bearer ${tok}` }, responseType: "blob",
      });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `${num}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { setErr("Téléchargement échoué"); }
  };

  if (loading) return <Spinner />;

  return (
    <>
      {err && <Alert type="error"><span>⚠</span><span>{err}</span></Alert>}
      {invoices.length === 0 ? (
        <div style={{ padding: 40, textAlign: "center", color: C.muted, background: "#fff", borderRadius: 12, border: `.5px solid ${C.border}` }}>
          Aucune facture émise pour le moment. Les factures apparaissent automatiquement à chaque paiement encaissé.
        </div>
      ) : (
        <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead><tr style={{ background: C.gray2 }}>
              {["Numéro", "Date", "Dossier", "Client", "HT", "TVA", "TTC", ""].map(h => (
                <th key={h} style={{ textAlign: h === "" ? "right" : "left", padding: "10px 14px", fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: ".07em", fontWeight: 700 }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {invoices.map(inv => (
                <tr key={inv.id} style={{ borderTop: `.5px solid ${C.border}` }} data-testid={`facture-${inv.numero}`}>
                  <td style={{ padding: "10px 14px", fontFamily: "monospace", fontWeight: 700, color: C.navy }}>{inv.numero}</td>
                  <td style={{ padding: "10px 14px", color: C.mid }}>{fmtDate(inv.date)}</td>
                  <td style={{ padding: "10px 14px", fontFamily: "monospace", color: C.mid, fontSize: 11 }}>{inv.parcoursId}</td>
                  <td style={{ padding: "10px 14px", color: C.mid }}>{inv.email || "—"}</td>
                  <td style={{ padding: "10px 14px", color: C.mid }}>{fmtEur(inv.montant_ht)}</td>
                  <td style={{ padding: "10px 14px", color: C.mid }}>{inv.tva_pct}%</td>
                  <td style={{ padding: "10px 14px", fontWeight: 700, color: C.navy }}>{fmtEur(inv.montant_ttc)}</td>
                  <td style={{ padding: "10px 14px", textAlign: "right" }}>
                    <Btn small onClick={() => download(inv.id, inv.numero)} data-testid={`download-${inv.numero}`}>PDF</Btn>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
